const shuffle = require("shuffle-array");

export function setGameData(state, action) {
  return setRandomizedGameData(state, action);

console.log('action setGameData', action);
  const newState = {...state};
  newState.game.data = [...action.data];

  return newState;
}

export function setGameDataIndex(state, action) {
  const newState = {...state};
  newState.game.dataIndex = action.data;

  return newState;
}

export function randomizedGameData(state, action) {

console.log('action randomizedGameData');
  const newState = {...state};
  newState.game.data = shuffle([...state.game.data]);

  return newState;
}

export function setRandomizedGameData(state, action) {

console.log('action setGameData', action);
  const newState = {...state};
  newState.game.data = [...action.data];

  return randomizedGameData(newState);
}

export function popChainPuzzleData(){}

export function setShouldRewardPoints(state, action) {
  // console.log('setShouldRewardPoints');
  const newState = {...state};
  newState.game.shouldRewardPoints = !!action.data;

  return newState;
}

export function addGamePoints(state, action) {

  const newState = {...state};
  newState.game.points += action.data;

  return newState;
}

export function reduceGamePoints(state, action) {
  const newState = {...state};
  newState.game = {...state.game};
  newState.game.points = newState.game.points - action.data;
  
  return newState;
}

export function setGamePoints(state, action) {
  const newState = {...state};
  newState.game = {...state.game};
  newState.game.points = action.data;
  
  return newState;
}

export function setGameAvatar(state, action) {

  const newState = {...state};
  newState.game.avatar = action.data;

  return newState;
}

export function setGameBet(state, action) {

  const newState = {...state};
  newState.game.bet = action.data;

  return newState;
}

export function setGameBetLock(state, action) {

  const newState = {...state};
  newState.game.betLocked = true;

  return newState;
}

export function setGameBetUnlock(state, action) {

  const newState = {...state};
  newState.game.betLocked = false;

  return newState;
}

export function setGameFocusLinkIndex(state, action) {

  const newState = {...state};
  newState.game.focusLinkIndex = action.data;

  return newState;
}

export function setIsAllowHintOnFocusLink(state, action) {

  const newState = {...state};
  newState.game.isAllowHintOnFocusLink = action.data;

  return newState;
}

export function setGameStatus(state, action) {
  const newState = {...state};
  newState.game.status = action.data;

  return newState;
}